
export function transformSecondsToMs(seconds: number): number {
  const ms = seconds * 1000;
  return Math.floor(ms);
}
